export default __webpack_public_path__ + "static/media/online-learning-using-tablet.61a1b542.png";